document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("change", function(e) {
    if (!e.target.matches(".select-option")) return;

    const select = e.target;
    const selected = e.target.options[e.target.selectedIndex];
    const price = selected.dataset.price / 100;
    const cprice = selected.dataset.cprice / 100;
    const selectedId = select.value;
    const moneyFormat = window.format;
    const priceBox = select.closest(".product-card-wrapper");
      if (priceBox) {
        priceBox.querySelector(".reg_price").innerHTML = moneyFormat.replace('{{amount}}', price);
        if(cprice > price){
          priceBox.querySelector(".compare_price").innerHTML = moneyFormat.replace('{{amount}}', cprice);
        }else{
          priceBox.querySelector(".compare_price").innerHTML = '';
        }
      }  
      priceBox.querySelector('[name="id"]').value = selectedId;
  });

  /****for PDP */
  function createHandle(inputString) {
    let handle = inputString.toLowerCase();
    handle = handle.replace(/\s+/g, '-');
    handle = handle.replace(/[^a-z0-9-]+/g, '');
    handle = handle.replace(/^-+|-+$/g, '');
    return handle;
  }
  function pdpLabelnfoAddition(){
    const JSON_SCRIPT_ID = 'variant_details';

    // Step 1: Parse JSON safely
    let raw = null;
    try {
      const el = document.getElementById(JSON_SCRIPT_ID);
      if (!el) throw new Error('#' + JSON_SCRIPT_ID + ' not found');
      raw = JSON.parse(el.textContent);
    } catch (err) {
    // console.error('Failed to parse variant_details JSON:', err);
      return;
    }

    // Step 2: Build lookup map using NUMBER as key
    const variantMap = {};  
    raw.forEach(item => {
      const key = Object.keys(item)[0];
      if (!key) return;

      const info = item[key][0];
      if (info && info['variant-id']) {
        variantMap[key.trim()] = {
          id: info['variant-id'],
          price: Number(info['variant-price']) || 0,
          number: Number(info[ 'number']) || 0,
          discount: Number(info['discount']) || 0,
          variantBadge: info['variant-badge']
        };
      }
    });

    // Step 3: Loop through all labels with class "btn"
    document.querySelectorAll('label.btn').forEach(label => {
      const spanText = label.getAttribute('data-qty');
      const labelValue = Number(spanText.trim()); // Convert label to NUMBER
      const spanLabel = label.getAttribute('data-title');
      const perPriceEl = label.querySelector('.per_price');
      const varBadgeEl = label.querySelector('.variant-badge');

      if (!perPriceEl) return;

      // Now match using number
      const variantData = variantMap[spanLabel];
      var priceObtained;
      if (variantData) {
        if(variantData.variantBadge != ''){
          let badgeClassName = createHandle(variantData.variantBadge);
          varBadgeEl.classList.add(badgeClassName);
          varBadgeEl.innerHTML = variantData.variantBadge;
        }
        const priceActual = variantData.price / 100;
        const litres = variantData.number;
        let priceObtained = priceActual / litres;

        let moneyFormat = window.format;
        let formattedPrice = moneyFormat.replace(/\{\{\s*amount\s*\}\}/, priceObtained.toFixed(2));
        if (formattedPrice.endsWith('.00')) {
          formattedPrice = formattedPrice.replace('.00', '');
        }
        let priceActualformat = moneyFormat.replace(/\{\{\s*amount\s*\}\}/, priceActual.toFixed(2));
        if (priceActualformat.endsWith('.00')) {
          priceActualformat = priceActualformat.replace('.00', '');
        }

        perPriceEl.innerHTML = '<div class="info-price">'+priceActualformat+'</div><div class="info-per-litre">'+ formattedPrice + ' / L </div>';
      }
    });
  }
  pdpLabelnfoAddition();
function reRenderMenberShip(variantId, sectionId) {
  if (!variantId || !sectionId) return;
  fetch(`${window.location.pathname}.js`)
    .then(res => res.json())
    .then(product => {  
      const variant = product.variants.find(v => v.id == variantId);
      if (!variant) return;

      // 12% discount → pay 88%
      const discountedPrice = Math.round(variant.price * 0.88 / 100);
      const section = document.getElementById('shopify-section-'+sectionId);
      if (!section) return;

      const priceEl = section.querySelector('[data-membership-price]');
      if (!priceEl) return;
      const formattedPrice = window.format.replace('{{amount}}', discountedPrice);

      priceEl.innerHTML = formattedPrice;
    })
    .catch(err => console.error('Membership price update failed', err));
}

    /***on variant change re-render updates */
  document.addEventListener("variant-change", (event) => {
    pdpLabelnfoAddition();
    console.log(event);
const variant = event.detail.variant;
        const sectionId = event.detail.sectionId || document.querySelector('[data-section]')?.dataset.section;
        console.log(sectionId, 'sectinId', variant, 'variant');
        
        if (variant && sectionId) reRenderMenberShip(variant.id, sectionId);
  });

  /**check for product recommendations and then trigger slider */

});
document.addEventListener('recommends-loaded', async () => {
  class SliderComponentNew extends SliderComponent {}
customElements.define('slider-component-recommend', SliderComponentNew);
});
// document.addEventListener('recommends-loaded', async () => {
//   const container = document.querySelector('product-recommendations');
//   if (!container) return;

//   const ul = container.querySelector('ul:not([data-wrapped])');
//   if (!ul) return;

//   // Ensure ID/attributes match theme expectations
//   const sectionId = ul.getAttribute('data-id') || 'recommendations';
//   ul.id = ul.id || `Slider-${sectionId}`;
//   ul.setAttribute('role', 'list');
//   ul.setAttribute('data-wrapped', 'true');

//   // Create slider-component and move UL inside it
//   const slider = document.createElement('slider-component');
//   slider.className = 'slider-mobile-gutter slider-component-desktop scroll-trigger animate--slide-in';

//   ul.parentNode.insertBefore(slider, ul);
//   slider.appendChild(ul);
//    ul.classList.add('slider', 'slider--desktop', 'slider--tablet', 'grid--peek');

//   // Build buttons (replace arrows with your SVG if you want)
//   const sliderButtons = document.createElement('div');
//   sliderButtons.className = 'slider-buttons';
//   sliderButtons.innerHTML = `
//     <button type="button" class="slider-button slider-button--prev" name="previous"
//       aria-label="Previous slide" aria-controls="${ul.id}">
//       <span class="svg-wrapper">←</span>
//     </button>

//     <div class="slider-counter caption">
//       <span class="slider-counter--current">1</span>
//       <span aria-hidden="true"> / </span>
//       <span class="visually-hidden">of</span>
//       <span class="slider-counter--total">${ul.querySelectorAll('li').length}</span>
//     </div>

//     <button type="button" class="slider-button slider-button--next" name="next"
//       aria-label="Next slide" aria-controls="${ul.id}">
//       <span class="svg-wrapper">→</span>
//     </button>
//   `;

//   if (ul.classList.contains('slider')) slider.appendChild(sliderButtons);

//   // debug
//   console.log('wrap-> slider created', { ulId: ul.id, liCount: ul.querySelectorAll('li').length });

//   // Wait for custom element definition and upgrade
//   try {
//     await customElements.whenDefined('slider-component');
//     if (typeof customElements.upgrade === 'function') {
//       try { customElements.upgrade(slider); } catch (e) { /* ignore */ }
//     }
//   } catch (err) {
//     console.warn('slider-component not defined yet:', err);
//   }

//   // Give the browser a frame to attach and then try native init
//   await new Promise((res) => requestAnimationFrame(res));

//   const tryNativeInit = () => {
//     if (typeof slider.init === 'function') {
//       try { slider.init(); console.log('called slider.init()'); return true; } catch (err) { console.warn('slider.init threw', err); }
//     }
//     if (typeof slider.connectedCallback === 'function') {
//       try { slider.connectedCallback(); console.log('called slider.connectedCallback()'); return true; } catch (err) { console.warn('connectedCallback threw', err); }
//     }
//     return false;
//   };

//   const nativeInitSucceeded = tryNativeInit();

//   // After native init, test whether buttons wired (we assume wiring means click handlers cause visible change)
//   const prevBtn = slider.querySelector('.slider-button--prev');
//   const nextBtn = slider.querySelector('.slider-button--next');

//   function buttonsAreWiredTest(done) {
//     if (!prevBtn || !nextBtn) return done(false);
//     let triggered = false;
//     const handler = () => { triggered = true; };
//     prevBtn.addEventListener('click', handler, { once: true });
//     nextBtn.addEventListener('click', handler, { once: true });

//     // simulate a click on next to check if theme handler intercepts
//     nextBtn.click();

//     // small timeout for handler to run
//     setTimeout(() => {
//       done(triggered);
//     }, 250);
//   }

//   buttonsAreWiredTest((wired) => {
//     if (wired) {
//       console.log('Slider buttons wired by native init — no fallback needed.');
//       return;
//     }

//     console.warn('Slider buttons not wired by native init — attaching fallback handlers that perform scrolling.');

//     // FALLBACK: slide-by-scrolling logic
//     const list = ul;
//     const items = Array.from(list.querySelectorAll('li'));
//     if (!items.length) return;

//     // Determine slide width: width of first item (including margin)
//     const firstItem = items[0];
//     const computed = window.getComputedStyle(firstItem);
//     const itemWidth = firstItem.getBoundingClientRect().width + parseFloat(computed.marginLeft || 0) + parseFloat(computed.marginRight || 0);

//     // Number of columns visible at a time (attempt to derive from slider class or fallback to 1)
//     let visibleCount = 1;
//     const gridClassMatch = Array.from(list.classList).find(c => c.startsWith('grid--') && c.includes('-col'));
//     if (gridClassMatch) {
//       const m = gridClassMatch.match(/grid--(\d+)-col/);
//       if (m) visibleCount = parseInt(m[1], 10) || 1;
//     }

//     const step = Math.round(itemWidth * visibleCount) || Math.round(itemWidth);

//     // Smooth scroll helper that keeps within bounds
//     const scrollToOffset = (offset) => {
//       const max = list.scrollWidth - list.clientWidth;
//       const target = Math.max(0, Math.min(max, offset));
//       list.scrollTo({ left: target, behavior: 'smooth' });
//     };

//     // compute current page index based on scrollLeft
//     const currentPage = () => Math.round(list.scrollLeft / step);

//     // attach fallback handlers
//     if (prevBtn) {
//       prevBtn.addEventListener('click', (ev) => {
//         // try to nudge native init first if exists
//         try { if (typeof slider.connectedCallback === 'function') slider.connectedCallback(); } catch (_) {}
//         const next = (currentPage() - 1) * step;
//         scrollToOffset(next);
//       });
//     }
//     if (nextBtn) {
//       nextBtn.addEventListener('click', (ev) => {
//         try { if (typeof slider.connectedCallback === 'function') slider.connectedCallback(); } catch (_) {}
//         const next = (currentPage() + 1) * step;
//         scrollToOffset(next);
//       });
//     }

//     // Accessibility: update counter on scroll
//     const counterCurrent = slider.querySelector('.slider-counter--current');
//     const counterTotal = slider.querySelector('.slider-counter--total');
//     const totalPages = Math.max(1, Math.ceil((list.scrollWidth) / step));
//     if (counterTotal) counterTotal.textContent = totalPages;

//     let rafId = null;
//     const updateCounter = () => {
//       if (rafId) cancelAnimationFrame(rafId);
//       rafId = requestAnimationFrame(() => {
//         const page = Math.min(totalPages, Math.max(1, currentPage() + 1));
//         if (counterCurrent) counterCurrent.textContent = page;
//       });
//     };

//     list.addEventListener('scroll', updateCounter, { passive: true });
//     // initial set
//     updateCounter();

//     console.log('fallback handlers attached: step, visibleCount, itemWidth', { step, visibleCount, itemWidth });
//   });

// });
